import React from "react";

const ContactDetails = () => {
  return (

<>



<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1>Contact Us</h1>
        </div>
      </div>
    </section>

    <section className="contact-details-section pt_120 pb_90">
      <div className="container">
        <div className="section-title centred mb_60">
          <span className="sub-title">Contact Details</span>
          <h2 className="title">Contact Information</h2>
        </div>

        <div className="row">
         
          {/* Phone */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div className="contact-info-item centred">
              <div className="contact-info-icon">
                <i className="fa-solid fa-phone"></i>
              </div>
              <h4 className="contact-info-title">Phone Number</h4>
              <div className="contact-info-text">
                <a href="tel:+918390907004">+91 8390907004</a>
                <a href="tel:+919922727744">+91 9922727744</a>
              </div>
            </div>
          </div>


          {/* Email */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div className="contact-info-item centred">
              <div className="contact-info-icon">
                <i className="fa-solid fa-envelope"></i>
              </div>
              <h4 className="contact-info-title">Email Address</h4>
              <div className="contact-info-text">
                <a href="mailto:booking@saitrupticabs.com">booking@saitrupticabs.com</a>
                <br />
              </div>
            </div>
          </div>



 {/* Location */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div className="contact-info-item centred">
              <div className="contact-info-icon">
                <i className="fa-solid fa-location-dot"></i>
              </div>
              <h4 className="contact-info-title">Our Location</h4>
              <div className="contact-info-text">
                <p>Yashoda splendid Park,
Office number D. Wing Dudulgaon Anandi,
ruial Sainath Chowk Alandi-412105</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>


 <section className="google-map-section">
      <div className="container">
     


<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2987.3278058415385!2d73.878514!3d18.678203!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c9f3b6572081%3A0xe1604b1fa320d9c!2sYashada%20Splendid%20Park%20Pro!5e1!3m2!1sen!2sin!4v1760781912260!5m2!1sen!2sin" width="100%" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>




        
      </div>
    </section>

</>
  );
};

export default ContactDetails;
